var React = require('react');

function CloseButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"white","stroke":"#1A1D31","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"15.5356","y":"7.7574","width":"1","height":"11","transform":"rotate(45 15.5356 7.7574)","fill":"white","stroke":"#1A1D31","key":1}),React.createElement("rect",{"y":"0.707107","width":"1","height":"11","transform":"matrix(-0.707107 0.707107 0.707107 0.707107 7.91406 7.20711)","fill":"white","stroke":"#1A1D31","key":2})]);
}

CloseButton.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseButton;

CloseButton.default = CloseButton;
